const shouldShowAssessmentTab = ({ isTeacher }) => {
  const showAssessmentTab = isTeacher;

  const getTabUrl = (fallbackUrl) =>
    showAssessmentTab ? 'assessments' : fallbackUrl;

  return {
    showAssessmentTab,
    getTabUrl,
  };
};

export default shouldShowAssessmentTab;
